<h2 mat-dialog-title>Filter profiles</h2>

<div mat-dialog-content class="body">
  <div class="row two">
    <mat-form-field appearance="outline">
      <mat-label>Min age</mat-label>
      <input matInput type="number" inputmode="numeric" min="32" max="32" [(ngModel)]="draft.ageMin" />
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Max age</mat-label>
      <input matInput type="number" inputmode="numeric" min="32" max="32" [(ngModel)]="draft.ageMax" />
    </mat-form-field>
  </div>

  <mat-form-field appearance="outline" class="full">
    <mat-label>Gender</mat-label>
    <mat-select [(ngModel)]="draft.gender">
      <mat-option value="man">Man</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline" class="full">
    <mat-label>Eye color</mat-label>
    <mat-select [(ngModel)]="draft.eyeColor">
      <mat-option value="blue">Blue</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline" class="full">
    <mat-label>Height</mat-label>
    <mat-select [(ngModel)]="draft.heightBand">
      <mat-option value="fivenine">5'9</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline" class="full">
    <mat-label>Pets</mat-label>
    <mat-select [(ngModel)]="draft.pets">
      <mat-option value="both">Dogs &amp; cats</mat-option>

    </mat-select>
  </mat-form-field>
</div>

<div mat-dialog-actions align="end" class="actions">
  <button mat-button type="button" (click)="clearAll()">Clear all</button>
  <button mat-button type="button" (click)="cancel()">Cancel</button>
  <button mat-flat-button color="primary" type="button" (click)="apply()">Apply</button>
</div>
